import script from "./formDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./formDialog.vue?vue&type=script&setup=true&lang=js"

import "./formDialog.vue?vue&type=style&index=0&id=e8b1deb6&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8b1deb6"]])

export default __exports__